import { useState } from 'react';
import { SectionIntro } from '@/landing/components';
import { Accordion, ManagedAccordionItem } from 'dreambel-ui';
import { t } from 'i18next';

export function Faq() {
  const [accordionValue, setAccordionValue] = useState<string>('');

  const faqTitle = (
    <>
      {t('faq.title.part1')}
      <i>{t('faq.title.know')}</i>
      <br /> {t('faq.title.part2')} <b>{t('faq.title.questions')}</b>
    </>
  );

  const faqQuestions = [
    {
      id: 'whatIsFramerie',
      question: t('faq.questions.whatIsFramerie.question'),
      answer: t('faq.questions.whatIsFramerie.answer'),
    },
    {
      id: 'freevsPremium',
      question: t('faq.questions.freevsPremium.question'),
      answer: t('faq.questions.freevsPremium.answer'),
    },
    {
      id: 'platforms',
      question: t('faq.questions.platforms.question'),
      answer: t('faq.questions.platforms.answer'),
    },
    {
      id: 'pricing',
      question: t('faq.questions.pricing.question'),
      answer: t('faq.questions.pricing.answer'),
    },
    {
      id: 'privacy',
      question: t('faq.questions.privacy.question'),
      answer: t('faq.questions.privacy.answer'),
    },
    {
      id: 'support',
      question: t('faq.questions.support.question'),
      answer: t('faq.questions.support.answer'),
    },
  ];

  return (
    <section id="faq" className="section faq">
      <SectionIntro title={faqTitle} subtitle={t('faq.subtitle')} />

      <div className="faq_container mt-12 w-full max-w-4xl mx-auto">
        <Accordion
          type="single"
          value={accordionValue}
          onValueChange={(value) => setAccordionValue(value as string)}
          collapsible={true}
        >
          {faqQuestions.map((faq) => (
            <ManagedAccordionItem
              key={faq.id}
              value={faq.id}
              title={faq.question}
            >
              <p className="text-md-on-surface-variant leading-relaxed">
                {faq.answer}
              </p>
            </ManagedAccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
